/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_DescriptionInputs */

const en_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Description`)
};

const fr_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du projet`)
};

const de_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektbeschreibung`)
};

const it_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione del progetto`)
};

const ru_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание проекта`)
};

const es_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción del proyecto`)
};

const zh_cn2_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目描述`)
};

const ja_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの説明`)
};

const hi_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना विवरण`)
};

const pt_pt2_options_general_project_description = /** @type {(inputs: Options_General_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição do projeto`)
};

/**
* | output |
* | --- |
* | "Project Description" |
*
* @param {Options_General_Project_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_description = /** @type {((inputs?: Options_General_Project_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_project_description(inputs)
	if (locale === "de") return de_options_general_project_description(inputs)
	if (locale === "it") return it_options_general_project_description(inputs)
	if (locale === "ru") return ru_options_general_project_description(inputs)
	if (locale === "es") return es_options_general_project_description(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_project_description(inputs)
	if (locale === "ja") return ja_options_general_project_description(inputs)
	if (locale === "hi") return hi_options_general_project_description(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_project_description(inputs)
	return en_options_general_project_description(inputs)
});